export const GENDERS = {
  MALE: 'male',
  FEMALE: 'female',
};

export const GENDERS_LABELS = {
  [GENDERS.MALE]: 'Male',
  [GENDERS.FEMALE]: 'Female',
};

export const GENDERS_OPTIONS = Object.keys(GENDERS_LABELS).map(key => ({
  value: key,
  label: GENDERS_LABELS[key],
}));
